import { get, post, put } from '../utils/axios'

export const getFilesImagesAPI = async (body) => {
  return await get('files/images', body)
}

export const createFilesImagesAPI = async (data) => {
  return await post('files/images', data)
}

export const updateFilesImagesAPI = async (param, data) => {
  return await put('files/images', param, data)
}
export const getTypeFilesImagesAPI = async () => {
  return await get('files/types/images')
}

export const createFilesDocsAPI = async (body) => {
  return await post('files/docs', body)
}
export const updateFilesDocsAPI = async (params, data) => {
  return await put('files/docs', params, data)
}
export const getFilesDocsAPI = async (body) => {
  return await get('files/docs', body)
}
export const getFilesDetailsDocsAPI = async (body) => {
  return await get('files/details/docs', body)
}
export const getTypeFilesDocsAPI = async () => {
  return await get('files/types/docs')
}

export const getTypeFilesTypeImagesAPI = async () => {
  return await get('files/types/images')
}

export const getFilesDetailsImagesAPI = async (body) => {
  return await get('files/details/images', body)
}

export const getTypeDocsAPI = async () => {
  return await get('edu/types')
}
